// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".react-select__option.custom-option--8aPDe:hover .action-icon--N7P5W{visibility:visible}.react-select__option.custom-option--8aPDe.option--is-disabled{pointer-events:none}.react-select__option.custom-option--8aPDe.option--is-disabled .option-children--Udp7o{color:#b4bccd}.react-select__option.custom-option--8aPDe .action-icon--N7P5W{visibility:hidden}.react-select__option.custom-option--8aPDe .option-children--Udp7o{word-break:break-word;min-height:16px}.react-select__option.custom-option--8aPDe .disabled-label--Qrhjh{color:#96a0b4}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-option": "custom-option--8aPDe",
	"action-icon": "action-icon--N7P5W",
	"option-children": "option-children--Udp7o",
	"disabled-label": "disabled-label--Qrhjh"
};
export default ___CSS_LOADER_EXPORT___;
